<template>
  <span>
    <v-icon small color="grey lighten-1" class="mx-2" v-show="entity.attachments.tags_count">
      {{ $vuetify.icons.values.tag }}
    </v-icon>
    <v-icon small color="grey lighten-1" class="mx-2" v-show="entity.attachments.comments_count">
      {{ $vuetify.icons.values.comment }}
    </v-icon>
    <v-icon small color="grey lighten-1" class="mx-2" v-show="entity.attachments.todos_count">
      {{ $vuetify.icons.values.todo }}
    </v-icon>
    <v-icon small color="grey lighten-1" class="mx-2" v-show="entity.attachments.reminders_count">
      {{ $vuetify.icons.values.reminder }}
    </v-icon>
    <v-icon small color="grey lighten-1" class="mx-2" v-show="entity.attachments.documents_count">
      {{ $vuetify.icons.values.file }}
    </v-icon>
  </span>
</template>

<script>
export default {
  props: {
    entity: { type: Object, required: true }
  }
}
</script>
